export const EMAIL_RULES = [
  { required: true, message: "Email address is required" },
  { type: "email", message: "Please enter a valid email address" },
];

/** Validate email on blur and on submit, not while typing */
export const EMAIL_VALIDATE_TRIGGER = "onBlur";

export const EMAIL_VERIFICATION_LOGIN_MESSAGE =
  "Please check your email to verify your account before logging in.";

export const PASSWORD_RULES = [
  { required: true, message: "Password is required" },
  { min: 8, message: "Password must be at least 8 characters" },
];

export const confirmPasswordRules = (passwordFieldName = "password") => [
  { required: true, message: "Please confirm your password" },
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue(passwordFieldName) === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Passwords do not match"));
    },
  }),
];

const NAME_PATTERN = /^[a-zA-Z][a-zA-Z\s'-]{0,49}$/;

export const firstNameRules = [
  { required: true, message: "First name is required" },
  { min: 2, message: "First name must be at least 2 characters" },
  { max: 50, message: "First name must be at most 50 characters" },
  {
    pattern: NAME_PATTERN,
    message: "First name may only contain letters, spaces, hyphens, and apostrophes",
  },
];

export const lastNameRules = [
  { required: true, message: "Last name is required" },
  { min: 2, message: "Last name must be at least 2 characters" },
  { max: 50, message: "Last name must be at most 50 characters" },
  {
    pattern: NAME_PATTERN,
    message: "Last name may only contain letters, spaces, hyphens, and apostrophes",
  },
];

const PHONE_FORMAT_PATTERN = /^\+?[\d\s().-]{10,20}$/;

export const PHONE_RULES = [
  { required: true, message: "Phone number is required" },
  {
    validator(_, value) {
      if (!value) {
        return Promise.reject(new Error("Phone number is required"));
      }
      const trimmed = String(value).trim();
      if (!PHONE_FORMAT_PATTERN.test(trimmed)) {
        return Promise.reject(
          new Error("Please enter a valid phone number (e.g. +1 (123) 456-7890)")
        );
      }
      const digits = trimmed.replace(/\D/g, "");
      if (digits.length < 10) {
        return Promise.reject(
          new Error("Phone number must contain at least 10 digits")
        );
      }
      if (digits.length > 15) {
        return Promise.reject(
          new Error("Phone number must contain at most 15 digits")
        );
      }
      return Promise.resolve();
    },
  },
];
